import React, { useEffect } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import Menu from "../components/admin/Sidebar/SideBar";
import Roles from "../pages/admin/roles/index.js";
import Usuarios from "../pages/admin/usuarios/index.js";
import TipoUsuarios from "../pages/admin/rangos/index.js";

import UpUsuarios from "../components/admin/usuarios/cargamasivaexel/CargaDeDatosExcelSeguro.js";
import Periodos from "../pages/admin/periodos/index.js";
import Cargos from "../pages/admin/cargos/index.js";
import Comidas from "../pages/admin/comidas/index.js";
import DiasInactivos from "../pages/admin/diasInactivos/index.js";
import ComidasPeriodo from "../pages/admin/comidasPeriodo";
import Reportes from "../pages/admin/reportes/Reportes.jsx";
import MenuComida from "../pages/admin/menu/MenuComida.jsx";
import SocketControlPanel from "../components/SocketControlPanel/SocketControlPanel.js";
import Tickets from "../pages/admin/tickets/index.js";
import CargaExcelAreas from "../pages/admin/areas/index.js";
import GestionNavidad from "../pages/admin/navidad/index.js";

const AdminLayout = ({ panelControl, setPanelControl }) => {
  const [rol, setRol] = React.useState(null);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("datauser"));
    setRol(data?.roles.code);
  }, []);

  const routes = [
    ...(rol === "1" || rol === "6"
      ? [
          // {
          //   path: "/sincronizar",
          //   name: "Centro de Sincronización",
          //   icon: "fas fa-sync",
          //   exact: true,
          //   component: <SocketControlPanel />,
          //   type: "menu",
          // },
          {
            path: "/usuarios",
            name: "Usuarios",
            icon: "fas fa-users",
            exact: true,
            component: <Usuarios />,
            type: "menu",
          },
          {
            path: "/userstype",
            name: "Tipos de usuarios",
            icon: "fas fa-users",
            exact: true,
            component: <TipoUsuarios />,
            type: "menu",
          },
          {
            path: "/upuser",
            name: "Carga de usuarios excel",
            icon: "fas fa-users",
            exact: true,
            component: <UpUsuarios />,
            type: "menu",
          },
        ]
      : []),
    ...(rol === "1"
      ? [
          {
            path: "/#",
            name: "Configuraciones",
            icon: "fas fa-gear",
            exact: true,
            type: "submenu",
            subRoutes: [
              {
                path: "/configuraciones/cargos",
                name: "Cargos",
                component: <Cargos />,
                icon: "fas fa-cog",
                exact: true,
                type: "submenu",
              },

              {
                path: "/configuraciones/roles",
                name: "Roles",
                component: <Roles />,
                icon: "fas fa-cog",
                exact: true,
                type: "submenu",
              },
              {
                path: "/configuraciones/carga-excel-areas",
                name: "Carga Excel - Áreas",
                component: <CargaExcelAreas />,
                icon: "fas fa-file-excel",
                exact: true,
                type: "submenu",
              },
              {
                path: "/configuraciones/gestion-navidad",
                name: "Gestión Navidad",
                component: <GestionNavidad />,
                icon: "fas fa-gift",
                exact: true,
                type: "submenu",
              },
            ],
          },
          {
            path: "/pedidos",
            name: "Pedidos",
            icon: "fas fa-utensils",
            exact: true,
            type: "submenu",
            subRoutes: [
              {
                path: "/pedidos/periodos",
                name: "Periodos",
                component: <Periodos />,
                icon: "fas fa-calendar-alt",
                exact: true,
                type: "submenu",
              },
              {
                path: "/pedidos/diasinactivos",
                name: "Dias Inactivos",
                component: <DiasInactivos />,
                icon: "fas fa-calendar-times",
                exact: true,
                type: "submenu",
              },
              {
                path: "/pedidos/comida",
                name: "Comida",
                component: <Comidas />,
                icon: "fas fa-utensils",
                exact: true,
                type: "submenu",
              },
              {
                path: "pedidos/periodoComida",
                name: "Comida por periodo",
                component: <ComidasPeriodo />,
                icon: "fas fa-calendar-alt",
                exact: true,
              },
            ],
          },
           {
            path: "/pedidos/tickets",
            name: "Gestión de Tickets",
            component: <Tickets />,
            icon: "fas fa-ticket-alt",
            exact: true,
          },
        ]
      : []),
    ...(rol === "1" || rol === "5"
      ? [
          {
            path: "/menu",
            name: "Menu de hoy",
            icon: "fa fa-pencil-square",
            exact: true,
            component: <MenuComida />,
            type: "menu",
          },
          // {
          //   path: "/pedidos/tickets",
          //   name: "Gestión de Tickets",
          //   component: <Tickets />,
          //   icon: "fas fa-ticket-alt",
          //   exact: true,
          // },
          {
            path: "/reportes",
            name: "Reportes",
            component: <Reportes />,
            icon: "fa fa-chart-pie",
            exact: true,
            activo: true,
            type: "menu",
          },
        ]
      : []),
  ];

  return (
    <Router>
      <Menu
        routes={routes}
        titulo="Opciones"
        subpath={"/"}
        panelControl={panelControl}
        setPanelControl={setPanelControl}
      >
        <Routes>
          <Route path="*" element={<> </>} />
          {routes.map((data) => {
            return data.subRoutes ? (
              data.subRoutes.map((subRoute) => (
                <Route
                  key={subRoute.path}
                  path={subRoute.path}
                  element={subRoute.component}
                ></Route>
              ))
            ) : (
              <Route
                key={data.path}
                path={data.path}
                element={data.component}
              ></Route>
            );
          })}
          <Route path="*" element={<Navigate to="/auth" />} />
        </Routes>
      </Menu>
    </Router>
  );
};

export default AdminLayout;
